import api from 'api'

export type CreateWorkerCredentialParams = {
  userId: number
  workerRequirementId: number
}

export type CreateWorkerCredentialResponse = {
  id: number
}

export async function createWorkerCredential({
  userId,
  workerRequirementId,
}: CreateWorkerCredentialParams): Promise<CreateWorkerCredentialResponse> {
  const result = await api.post<CreateWorkerCredentialResponse>(
    `/admin/credentials/users/${userId}`,
    { workerRequirementId }
  )
  return result.data
}
